import { useTranslation } from 'react-i18next';
import ReportingDashboardSection, {
    SectionItem,
    SectionProps,
} from './ReportingDashboardSection';
import { useSelector } from '../../../../../store/hooks';
import { GridItemSpans } from '../../../../../controls/ResponsiveGrid/ResponsiveGridItem';
import CategoriesChartTile from '../tiles/CategoriesChartTile/CategoriesChartTile';
import AircraftRegNumbersChartTile from '../tiles/AircraftRegNumbersChartTile/AircraftRegNumbersChartTile';
import RoutesTableTile from '../tiles/RoutesTableTile/RoutesTableTile';

type TileKey = 'topCategories' | 'topArns' | 'topRoutes';

const itemSpans: Record<TileKey, GridItemSpans> = {
    topCategories: {
        desktopSpan: 8,
    },
    topRoutes: {
        desktopSpan: 4,
    },
    topArns: {
        desktopSpan: 8,
    },
} as const;

const ConversationsSection: React.FC<SectionProps> = ({ className }) => {
    const { t } = useTranslation();

    const { previousRange, currentRange } = useSelector(
        (x) => x.reportingDashboard
    );

    return previousRange && currentRange ? (
        <ReportingDashboardSection className={className}>
            <>
                <SectionItem {...itemSpans.topCategories}>
                    <CategoriesChartTile
                        title={t('ReportingDashboard_TopCategories')}
                        currentItems={
                            currentRange.conversationBreakdowns.categories
                        }
                    />
                </SectionItem>
                <SectionItem {...itemSpans.topRoutes}>
                    <RoutesTableTile
                        title={t('ReportingDashboard_TopRoutes')}
                        previousItems={
                            previousRange.conversationBreakdowns.routes
                        }
                        currentItems={
                            currentRange.conversationBreakdowns.routes
                        }
                    />
                </SectionItem>
                <SectionItem {...itemSpans.topArns}>
                    <AircraftRegNumbersChartTile
                        title={t('ReportingDashboard_TopAircraftRegNumbers')}
                        currentItems={
                            currentRange.conversationBreakdowns
                                .aircraftRegNumbers
                        }
                    />
                </SectionItem>
            </>
        </ReportingDashboardSection>
    ) : null;
};

export default ConversationsSection;
